import MarkedField from '../../components/marked-field'
import requiredValidator from '../../components/validators/required-validator'
import positiveIntegerValidator from '../../components/validators/positive-integer-validator'
import minMaxValidatorFactory from '../../components/validators/min-max-validator-factory'
import regexPatternValidator from './regex-pattern-validator'

/**
 * Retrieves min and max values from given input fields
 * @param minEl element containing minimum value
 * @param maxEl element containing maximum value
 * @returns {{min: null, max: null}}
 */
function getMinMaxInputValues(minEl, maxEl) {
	let min = null
	let max = null

	if (minEl.is(':visible')) {
		min = minEl.val()
	}

	if (maxEl.is(':visible')) {
		max = maxEl.val()
	}

	return { min, max }
}

/**
 * Renders input validation fields for a widget with necessary validators
 * @returns {renderInputValidationFields}
 */
function renderInputValidationFields() {
	const minEl = this.$('[name=minimumLength]')
	const maxEl = this.$('[name=maximumLength]')
	const minMaxValidators = [
		requiredValidator,
		positiveIntegerValidator,
		minMaxValidatorFactory(
			() => getMinMaxInputValues(minEl, maxEl)
		)
	]

	this.minimumLengthMarkedField = new MarkedField({
		el: minEl,
		validators: minMaxValidators
	}).render()

	this.maximumLengthMarkedField = new MarkedField({
		el: maxEl,
		validators: minMaxValidators
	}).render()

	this.customExpressionMarkedField = new MarkedField({
		el: this.$('[name=customExpression]'),
		validators: [requiredValidator, regexPatternValidator]
	}).render()
}

export { getMinMaxInputValues }
export { renderInputValidationFields }